import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiUser, FiBell } from 'react-icons/fi';

export default function Header() {
  const { user } = useAuth();

  return (
    <header className="bg-white shadow-sm">
      <div className="flex justify-between items-center px-6 py-4">
        {/* العنوان مخفي في الموبايل (يظهر في Layout) */}
        <h2 className="text-xl font-semibold text-gray-800 hidden lg:block">
          Welcome back, {user?.full_name || user?.username || 'Admin'}!
        </h2>
        
        <div className="flex items-center space-x-4 ml-auto">
          <button className="p-2 text-gray-400 hover:text-gray-600 relative">
            <FiBell className="w-5 h-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>
          
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
              <FiUser className="w-4 h-4 text-primary-600" />
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-medium text-gray-700">
                {user?.full_name || user?.username}
              </p>
              <p className="text-xs text-gray-500 capitalize">
                {user?.role?.name || user?.role?.code || 'User'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
